// Shared labels for the feedback pages.

export const FEEDBACK_STATUS = {
  open: { label: 'Open', className: 'badge-success' },
  not_started: { label: 'Not open yet', className: 'badge-info' },
  closed: { label: 'Closed', className: 'badge-secondary' }
};

export const TEMPLATE_NAMES = { A: 'Standard', B: 'Improved' };

export const MODE_NAMES = { named: 'Named', optional: 'Optional names', anonymous: 'Anonymous' };
